import { gql } from '@apollo/client';

export const COPY_DATASET = gql`
  mutation CopyDataset($input: CopyDatasetInput!) {
    workspaceDataset: copyDataset(input: $input) {
      id
    }
  }
`;
